module.exports = __webpack_public_path__ + "img/icons_24.17b437b7.svg";